import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';

import ManageProductActionModalContainer from './ManageProductActionModalContainer';
import {setMfproductManageProductModal} from '../../../../store/slice/ManufSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '95%', xs: '95%' },
  height: { lg: '95%', xs: '95%' },
  borderRadius: 3,
  //overflow:'scroll',
  p: 1,
  backgroundColor:'secondary.lighter',
};

export default function ManageProductActionModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);;
  const {ManageProductModalOpen, mfproductObj} = useSelector((state)=>state.manufslice.mfproductDashboard);

  useEffect(()=>{
  },[ManageProductModalOpen])

  const handleModalClose=()=>{
    handleClose();
    dispatch(setMfproductManageProductModal(false));
  }
  return (
    <Modal
       open={ManageProductModalOpen===undefined?false:ManageProductModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h5"  sx={{borderBottom:'1px solid #0050b3'}}>
              Manage Product1 @ {mfproductObj.title}
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
          </Grid>
        </Grid>
        <Grid item>
            < ManageProductActionModalContainer/>
        </Grid>

      </Box>
    </Modal>
  );
}